import { LuSearch, LuCheck } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "43%",
      rows: {
        row1: [
          {
            name: "importShipmentAirlineCode",
            label: "Airline",
            component: "text-field",
            placeholder: "All",
            width: "25%",
          },
          {
            name: "importShipmentAirline",
            label: "Airline",
            component: "text-field",
            endIconName: "LuSearch",
            width: "75%",
            type: "autocomplete",
            endpoint: "getAirline",
            autofillTargets: {
              importShipmentAirlineCode: "code",
              importShipmentMAWBNo: "prefix",
            },
          },
        ],

        row2: [
          {
            name: "importShipmentFlightNo",
            label: "Flight No",
            component: "text-field",
            width: "50%",
          },

          {
            name: "importShipmentFlightDate",
            label: "Fligh/Inward Date",
            component: "dateselector",
            disabled: false,
            width: "50%",
          },
        ],

        row3: [
          {
            name: "importShipmentIGMNo",
            label: "IGM No",
            component: "text-field",
            width: "50%",
          },
          {
            name: "importShipmentIGMDate",
            label: "IGM Date",
            component: "dateselector",
            disabled: false,
            width: "50%",
          },
        ],

        row4: [
          {
            name: "importShipmentMAWBNo",
            label: "MAWB No",
            component: "text-field",
            width: "50%",
            dataType:"int"

          },
          {
            name: "importShipmentMAWBDate",
            label: "MAWB Date",
            component: "dateselector",
            width: "50%",
          },
        ],
        row5: [
          {
            name: "importShipmentHAWBNo",
            label: "HAWB No",
            component: "text-field",
            width: "50%",
          },
          {
            name: "importShipmentHAWBDate",
            label: "HAWB Date",
            component: "dateselector",
            width: "50%",
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "32%",
      rows: {
        row1: [
          {
            name: "importShipmentShippingLine",
            label: "Line No",
            component: "text-field",
            placeholder: "All",
            type:"autocomplete",
            endpoint:"getShipLineMaster",
          },
        ],

        row2: [
          {
            name: "importShipmentPackages",
            label: "Packages",
            component: "text-field",
            width: "50%",
            dataType: "int",
          },

          {
            name: "importShipmentPackageType",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],

        row3: [
          {
            name: "importShipmentGrossWeight",
            label: "Gross Wt",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importShipmentWeightType",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],

        row4: [
          {
            name: "importShipmentNetWeight",
            label: "Net Wt",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importShipmentNetWeightType",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
        row5: [
          {
            name: "importShipmentVolume",
            label: "Volume",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importShipmentVolumeType",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
            type: "autocomplete",
            endpoint: "getVolume",
          },
        ],
        row6: [
          {
            name: "importShipmentChargeableWeight",
            label: "Chargeable Wt",
            component: "text-field",
            width: "50%",
            dataType: "float",
          },
          {
            name: "importShipmentChargeableWeightType",
            component: "text-field",
            endIconName: "LuSearch",
            width: "50%",
            type: "autocomplete",
            endpoint: "getQuantity",
          },
        ],
      },
    },
    {
      column: "column3",
      columnWidth: "20%",
      rows: {
        row1: [
          {
            name: "importShipmentMarksandNos",
            actionText: "Marks & Nos : Initialize",
            component: "textarea",
            placeholder: "All",
            height: 70,
          },
        ],
        row2: [
          {
            name: "Check IGM Status",
            icon: "LuCheck",
            iconColor: "var(--brand-800)",
            actionText: "Check IGM Status",
            actionTextColor: "var(--brand-800)", // ✅ this will be used for action text color
            component: "typographytext",
          },
        ],
        row3: [
          {
            name: "Check AWB Status",
            icon: "LuCheck",
            iconColor: "var(--brand-800)",
            actionText: "Check AWB Status",
            actionTextColor: "var(--brand-800)", // ✅ this will be used for action text color
            component: "typographytext",
          },
        ],
        row4: [
          {
            name: "Container",
            label: "Container",
            component: "outlinebutton",
            width: "100%",
            action: "openSubDialog",
            subComponent: "Container",
          },
        ]


      }
    }
  ]
};
